module.exports = __webpack_public_path__ + "static/media/rightInputGain.01ce502f.png";